// extracted by mini-css-extract-plugin
export default {"checkboxContent":"checkout-total-checkbox-module--checkboxContent--Cp13H","url":"checkout-total-checkbox-module--url--3hx4W"};